interface HotSaleIconProps {
  className?: string
}
export const HotSaleIcon = ({ className }: HotSaleIconProps) => {
  return (
    <svg
      className={className}
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='25'
      viewBox='0 0 27 31'
      fill='none'
    >
      <path
        d='M21.3252 10.1293C21.056 10.0049 20.742 10.0261 20.4932 10.1835C20.2436 10.3427 20.0921 10.6185 20.0921 10.9148V12.3603C20.0921 12.8385 19.7036 13.227 19.2254 13.227C18.7972 13.227 18.4349 12.9189 18.3647 12.5C17.6596 8.12936 14.4485 0.978088 13.1587 0.978088C11.8689 0.978088 8.6578 8.12936 7.95361 12.4949C7.88254 12.9189 7.52027 13.227 7.09202 13.227C6.61386 13.227 6.22536 12.8385 6.22536 12.3603V10.9147C6.22536 10.6185 6.07386 10.3426 5.82421 10.1835C5.57455 10.026 5.2622 10.0049 4.99226 10.1293C2.04184 11.5055 0.158691 17.5028 0.158691 21.027C0.158691 26.64 5.50429 30.5603 13.1587 30.5603C20.8131 30.5603 26.1587 26.64 26.1587 21.027C26.1587 17.5028 24.2755 11.5055 21.3252 10.1293Z'
        fill='url(#paint0_linear_3827_644)'
      />
      <path
        d='M17.3624 18.8383C17.2041 18.5827 16.9256 18.427 16.6252 18.427H14.7023L13.999 15.6171C13.911 15.265 13.6139 15.0052 13.2533 14.9654C12.8852 14.9274 12.5458 15.1161 12.3833 15.4394L8.9166 22.3727C8.78204 22.641 8.79642 22.9601 8.95468 23.2157C9.11293 23.4713 9.39142 23.627 9.69186 23.627H11.6148L12.3181 26.4369C12.4061 26.789 12.7032 27.0489 13.0637 27.0886C13.4346 27.1277 13.7748 26.9317 13.9338 26.6147L17.4005 19.6813C17.535 19.413 17.5206 19.0939 17.3624 18.8383Z'
        fill='url(#paint1_linear_3827_644)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_3827_644'
          x1='13.1587'
          y1='30.5603'
          x2='13.1587'
          y2='0.978088'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FD5900' />
          <stop offset='1' stopColor='#FFDE00' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_3827_644'
          x1='13.1585'
          y1='27.0936'
          x2='13.1585'
          y2='14.9606'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFE59A' />
          <stop offset='1' stopColor='#FFFFD5' />
        </linearGradient>
      </defs>
    </svg>
  )
}
